import { useQuery } from "@tanstack/react-query";
import { SystemLicenses } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { onError } from "util/conditional/onError";
export const DRAWDOWN_LICENSE_REMAINING_TRAFFIC_QUERY_KEY = "drawdown_license_remaining_traffic";
const getTraffic = (graphDays = 30) => SystemLicenses.getRemaining(graphDays);
const useDrawDownLicenseRemainingTraffic = (graphDays = 30) => {
  const { data, isFetching, isLoading, isError, refetch } = useQuery({
    queryKey: [DRAWDOWN_LICENSE_REMAINING_TRAFFIC_QUERY_KEY, graphDays],
    queryFn: () => onError(getTraffic(graphDays), (errorThrown) => {
      if (!(errorThrown.status === 404)) {
        UserNotification.error(`Loading drawDown license remaining traffic failed with: ${errorThrown}`);
      }
    })
  });
  return {
    data,
    isFetching,
    isLoading,
    isError,
    refetch
  };
};
export default useDrawDownLicenseRemainingTraffic;
